import { render, staticRenderFns } from "./VestingForm.vue?vue&type=template&id=391d7cb7&scoped=true"
import script from "./VestingForm.vue?vue&type=script&lang=js"
export * from "./VestingForm.vue?vue&type=script&lang=js"
import style0 from "./VestingForm.vue?vue&type=style&index=0&id=391d7cb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391d7cb7",
  null
  
)

export default component.exports